import { getCommonCheckoutSteps } from '@flows/configs/common'
import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import contents_bike from './contents_bike'
import contents_bike_insured_sum from './contents_bike_insured_sum'
import contents_birthday from './contents_birthday'
import contents_confirm_location from './contents_confirm_location'
import contents_damages from './contents_damages'
import contents_deductibles from './contents_deductibles'
import contents_glass from './contents_glass'
import contents_instant from './contents_instant'
import contents_insurance_cancelled from './contents_insurance_cancelled'
import contents_insurance_choice from './contents_insurance_choice'
import contents_insurance_owned from './contents_insurance_owned'
import contents_insured_amount from './contents_insured_amount'
import contents_living_space from './contents_living_space'
import contents_location from './contents_location'
import contents_natural_disasters from './contents_natural_disasters'
import contents_permanent_residence from './contents_permanent_residence'
import contents_quote from './contents_quote'
import contents_wg_insured from './contents_wg_insured'
import contents_wg_members from './contents_wg_members'
import renters_bundle_contents_instant from './renters_bundle_contents_instant'

export const getSteps = (stepParams: StepConfigParams) =>
  ({
    contents_insurance_choice: contents_insurance_choice(stepParams),
    contents_birthday: contents_birthday(stepParams),
    contents_insured_amount: contents_insured_amount(stepParams),
    contents_living_space: contents_living_space(stepParams),
    contents_permanent_residence: contents_permanent_residence(stepParams),
    contents_insurance_owned: contents_insurance_owned(stepParams),
    contents_damages: contents_damages(stepParams),
    contents_insurance_cancelled: contents_insurance_cancelled(stepParams),
    contents_deductibles: contents_deductibles(stepParams),
    contents_glass: contents_glass(stepParams),
    contents_natural_disasters: contents_natural_disasters(stepParams),
    contents_location: contents_location(stepParams),
    contents_bike: contents_bike(stepParams),
    contents_bike_insured_sum: contents_bike_insured_sum(stepParams),
    contents_wg_insured: contents_wg_insured(stepParams),
    contents_wg_members: contents_wg_members(stepParams),
    contents_confirm_location: contents_confirm_location(stepParams),
    contents_quote: contents_quote(stepParams),
    contents_instant: contents_instant(stepParams),
    renters_bundle_contents_instant: renters_bundle_contents_instant(stepParams),
    contents_personal_details: personal_details(stepParams, {
      nextStep: 'gender',
      omitFields: ['address', 'birthdate'],
      policyPreviewConsent: {
        titleKey: 'sharedFlows_contentsNxt:steps.personal_details.policyPreview.title',
        textKey: 'sharedFlows_contentsNxt:steps.personal_details.policyPreview.text',
      },
      translations: {
        title: 'sharedFlows_common:steps.personal_details.title',
        birthdateLabel: 'sharedFlows_common:steps.personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_common:steps.email_and_name.checkboxes.marketingOptIn',
        minAgeError: 'sharedFlows_common:generic.errors.min_age',
        maxAgeError: 'sharedFlows_common:generic.errors.max_age',
      },
    }),
    ...getCommonCheckoutSteps(),
  }) as const satisfies AnySteps
